const serviceData = [
    {
      id: 1,
      title: "City Transfer",
      icon: "ri-map-pin-2-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 2,
      title: "Whole  City Tour",
      icon: "ri-community-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 3,
      title: "Unlimited Miles Car Rental",
      icon: "ri-roadster-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 4,
      title: "Fast & Easy Booking",
      icon: "ri-timer-flash-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 5,
      title: "Many Pickup Locations",
      icon: "ri-map-pin-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  
    {
      id: 6,
      title: "Airport Transfer",
      icon: "ri-flight-takeoff-line",
      desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
    },
  ];
  
  export default serviceData;